import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EDSFiltersRequestBody } from '@/features/eds/types/api/requests/EDSFiltersRequestBody';
import { ClaimantsListDataType } from './types/claimantsSliceTypes';
import { claimantsSliceInitialState } from './constants/claimantsSliceConstants';

const claimantsListSlice = createSlice({
  name: 'claimantsList',
  initialState: claimantsSliceInitialState,
  reducers: {
    incrementClaimantsListPage(state, { payload: claimId }: PayloadAction<string>) {
      state.claimantsListByClaimId[claimId] = {
        ...state.claimantsListByClaimId[claimId],
        pagination: {
          ...state.claimantsListByClaimId[claimId].pagination,
          page: state.claimantsListByClaimId[claimId].pagination.page++,
        },
      };
    },
    resetClaimantsListByClaimId: (state, { payload: claimId }: PayloadAction<string>) => {
      delete state.claimantsListByClaimId[claimId];
    },
    getClaimantsList: (_, _action: PayloadAction<EDSFiltersRequestBody | undefined>) => {},
    getClaimantsListSuccess: (
      state,
      {
        payload: { data, claimId, shouldRewrite = true },
      }: PayloadAction<{ claimId: string; data: ClaimantsListDataType; shouldRewrite?: boolean }>,
    ) => {
      state.claimantsListByClaimId[claimId] = shouldRewrite
        ? data
        : {
            listings: [...state.claimantsListByClaimId[claimId].listings, ...data.listings],
            pagination: { ...data.pagination },
          };
      state.statuses.isClaimantsListLoading = false;
    },
    setClaimantsListLoadingStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isClaimantsListLoading = payload;
    },
  },
});

export const {
  incrementClaimantsListPage,
  getClaimantsList,
  getClaimantsListSuccess,
  setClaimantsListLoadingStatus,
  resetClaimantsListByClaimId,
} = claimantsListSlice.actions;

export const claimantsListReducer = claimantsListSlice.reducer;
export const claimantsListReducerPath = claimantsListSlice.reducerPath;
